import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SecondaryButton from "segments/desktop/core-components/button/secondary-button/secondary-button";
import { StyledHighlightCard } from "./highlight-card-component.scss";
import classnames from "classnames";
const HighlightCard = ({ imageUrl, title, description, articleLink, isDesktop })=>{
    const BUTTON_TEXT = "Learn more";
    return /*#__PURE__*/ _jsxs(StyledHighlightCard, {
        className: classnames("highlight-card", {
            "is-desktop": isDesktop
        }),
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "highlight-image",
                children: /*#__PURE__*/ _jsx("img", {
                    src: imageUrl,
                    alt: title
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "card-content",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "highlight-title",
                        children: title
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "highlight-description",
                        children: description
                    }),
                    articleLink && /*#__PURE__*/ _jsx("div", {
                        className: "button-container",
                        children: /*#__PURE__*/ _jsx(SecondaryButton, {
                            buttonText: BUTTON_TEXT,
                            withoutUnderline: true,
                            url: articleLink,
                            isOpenLinkInNewTab: true
                        })
                    }),
                    !articleLink && /*#__PURE__*/ _jsx("div", {
                        className: "button-place-holder"
                    })
                ]
            })
        ]
    });
};
export default HighlightCard;
